<template>
    <div class="newMsg">
        <div class="breadcrumb">{{actionText}}
            <el-button type="primary" class="right_f" @click="cancel">取消</el-button>
            <el-button type="primary" class="right_f" @click="saveMsg">保存</el-button>
        </div>

        <div style="margin-top:20px">
            <el-form ref="form" :rules="rules" :model="form" label-width="160px">
                <el-form-item label="消息用途：" prop="msgPurpose">
                    <el-input v-model="form.msgPurpose" placeholder="请输入消息用途" class="myInput" :disabled="edit"></el-input>
                </el-form-item>
                <el-form-item label="消息类型:" required>
                    <el-select v-model="form.msgType" style="width:40%;" :disabled="edit">
                        <el-option label="类型一" value="1"></el-option>
                        <el-option label="类型二" value="2"></el-option>
                        <el-option label="类型三" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="推送范围:" required>
                    <el-select v-model="form.pushRange" style="width:40%;" :disabled="edit">
                        <el-option label="全部学校" value="1"></el-option>
                        <el-option label="部分学校" value="2"></el-option>
                        <el-option label="部分学生" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <div style="margin: 20px 20px 20px 160px" v-if="form.pushRange=='2'">
                    <el-select v-model="school" style="width:40%;display:inline-block;" filterable>
                        <el-option v-for="item in options" :label="item.name" :value="item.rootUnid" :key="item.rootUnid"></el-option>
                    </el-select>
                    <el-button type="primary" @click="addCamp" :disabled="edit">添加</el-button>
                    <div class="campsBox">
                        <div v-for="(item,$index) in schoolsArr" class="s_item">{{item.name}}
                            <i class="el-icon-circle-close closeIcon" @click="delCampOrStu($index,1)"></i>
                        </div>
                    </div>
                </div>
                <div style="margin: 20px 20px 20px 160px" v-if="form.pushRange=='3'">
                    <el-input v-model="student" placeholder="请输入uid" class="myInput" type="number"></el-input>
                    <el-button type="primary" @click="addStu" :disabled="edit">添加</el-button>
                    <div class="campsBox">
                        <div v-for="(item,$index) in studentArr" class="s_item">{{item}}
                            <i class="el-icon-circle-close closeIcon" @click="delCampOrStu($index,0)"></i>
                        </div>
                    </div>
                </div>
                <el-form-item label="封面图标:" prop="coverPic" v-if="form.msgType!='3' && !edit">
                    <el-upload :action="actionUrl" :with-credentials='true' accept="image/*" name="uploadFile" type="drag" class="upload-demo"
                        :thumbnail-mode="true" :on-error="handleError" :on-success="handleSuccess">
                        <i class="el-icon-upload"></i>
                        <div class="el-dragger__text">将文件拖到此处，或
                            <em>点击上传</em>
                        </div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="标题：" prop="msgHeadline" v-if="form.msgType!='3'">
                    <el-input v-model="form.msgHeadline" placeholder="请输入标题" class="myInput"></el-input>
                </el-form-item>
                <el-form-item label="副标题：" prop="msgSubheadline" v-if="form.msgType=='1'">
                    <el-input v-model="form.msgSubheadline" placeholder="请输入副标题" class="myInput"></el-input>
                </el-form-item>
                <el-form-item label="消息内容：" prop="msgContent" v-if="form.msgType!='1'">
                    <el-input type="textarea" :autosize="{minRows: 5}" class="msgContent" placeholder="请输入消息内容" v-model="form.msgContent"></el-input>
                </el-form-item>
                <el-form-item label="跳转h5地址：" prop="redirectH5Url" v-if="form.msgType=='1'">
                    <el-input v-model="form.redirectH5Url" placeholder="请输入h5地址" class="myInput"></el-input>
                </el-form-item>
            </el-form>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                actionText: "消息推送 > 新增",
                actionUrl: this.$util.domain + '/adminapi/v1/basicTools/upload/one?uploadImageType=7',
                edit: false,
                msgId: null,
                options: [],
                student: "",
                studentArr: [],
                school: "",
                schoolsArr: [],
                form: {
                    msgPurpose: "",
                    msgType: "1",
                    pushRange: "1",
                    coverPic: "",
                    msgHeadline: "",
                    msgSubheadline: "",
                    msgContent: "",
                    redirectH5Url: ""
                },
                rules: {
                    msgPurpose: [
                        { required: true, message: "请输入消息用途", trigger: 'blur' },
                        { min: 1, max: 20, message: "消息用途最多输入20个字符", trigger: 'blur' }
                    ],
                    coverPic: [
                        { required: true, message: "请上传封面图标", trigger: 'change' }
                    ],
                    msgHeadline: [
                        { required: true, message: "请输入标题", trigger: 'blur' },
                        { min: 1, max: 20, message: "消息标题最多输入20个字符", trigger: 'blur' }
                    ],
                    msgSubheadline: [
                        { required: true, message: "请输入副标题", trigger: 'blur' },
                        { min: 1, max: 60, message: "消息副标题最多输入60个字符", trigger: 'blur' }
                    ],
                    msgContent: [
                        { required: true, message: "请输入消息内容", trigger: 'blur' },
                        { min: 1, max: 60, message: "消息内容最多输入60个字符", trigger: 'blur' }
                    ],
                    redirectH5Url: [
                        { required: true, message: "请输入h5地址", trigger: 'blur' }
                    ]
                }
            }
        },
        mounted() {
            this.getschoolandunid();
        },
        methods: {
            handleError(response) {
                if (response.status === 403) {
                    this.SIGNOUT();
                    location.href = '/#';
                }

                this.$util.errorMsg('上传失败');
            },
            handleSuccess(response) {
                if (response.error !== 10000) {
                    this.$util.errorMsg('上传失败');
                } else {
                    this.form.coverPic = response.data;
                }
            },
            cancel() {
                let url = location.href;
                location.href = url.replace("newMsg", "msgPush");
            },
            //获取消息详情
            getMsgDetail(msgId) {
                this.actionText = "消息推送 > 编辑";
                this.msgId = msgId;
                this.edit = true;
                let url = this.$util.domain + "/adminapi/v1/secretary/detail";
                this.$http({
                    url,
                    method: 'GET',
                    params: { msgId }
                }).then((response) => {
                    if (response.data.error == 10000) {
                        let data = response.data.data;
                        if (data.pushRange == 2) {
                            let myArr = data.pushContentList.split(",");
                            this.options.forEach(item => {
                                myArr.forEach(ele => {
                                    if (item.rootUnid == ele) {
                                        this.schoolsArr.push({
                                            name: item.name,
                                            rootUnid: ele
                                        })
                                    }
                                })

                            });
                        } else if (data.pushRange == 3) {
                            this.studentArr = data.pushContentList.split(",");
                        }
                        this.form = {
                            msgPurpose: data.msgPurpose,
                            msgType: data.msgType + "",
                            pushRange: data.pushRange + "",
                            coverPic: data.coverPic,
                            msgHeadline: data.msgHeadline,
                            msgSubheadline: data.msgSubheadline,
                            msgContent: data.msgContent,
                            redirectH5Url: data.redirectH5Url
                        };
                    }
                })
            },
            //获取所有学校
            getschoolandunid() {
                let url = this.$util.domain + '/adminapi/v1/basicTools/allSchools';
                this.$http({
                    url,
                    method: 'GET'
                }).then((response) => {
                    if (response.data.error == 10000) {
                        response.data.data.splice(0, 1);
                        this.options = response.data.data;//给option数组赋值，这里要在下拉列表里面展示出来
                        let id = this.$util.getUrlParam("id") * 1;
                        if (id) {
                            this.getMsgDetail(id);
                        }
                    } else {
                        this.$util.errorMsg(response.data.message, '提示');
                    }
                })
            },
            //添加学校
            addCamp() {
                let name;
                let rootUnid = this.school;
                this.school = "";
                if (!rootUnid || this.schoolsArr.length == 20) {
                    return;
                }
                //根据rootUnid获取学校的名称;
                for (let i = 0; i < this.options.length; i++) {
                    if (this.options[i].rootUnid == rootUnid) {
                        name = this.options[i].name;
                    }
                }
                //判断数组是否为空；不为空则判断是否添加的学校已存在；否则直接添加;
                if (this.schoolsArr.length) {
                    for (let i = 0; i < this.schoolsArr.length; i++) {
                        if (this.schoolsArr[i].rootUnid == rootUnid) {
                            return;
                        }
                    }
                }
                this.schoolsArr.push({ name, rootUnid });
            },
            //添加学生
            addStu() {
                let uid = this.student;
                this.student = "";
                if (!uid || this.studentArr.length == 20) {
                    return;
                }
                //判断数组是否为空；不为空则判断是否添加的学生已存在；否则直接添加;
                if (this.studentArr.length) {
                    for (let i = 0; i < this.studentArr.length; i++) {
                        if (this.studentArr[i] == uid) {
                            return;
                        }
                    }
                }
                this.studentArr.push(uid);
            },
            //去除某个学校或学生
            delCampOrStu($index, type) {
                if (type == 1) {
                    this.schoolsArr.splice($index, 1);
                } else if (type == 0) {
                    this.studentArr.splice($index, 1);
                }

            },
            //保存
            saveMsg() {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        let url = this.$util.domain + "/adminapi/v1/secretary/add";
                        let pushContentList = "";
                        let params = {};

                        if (this.edit) {
                            url = this.$util.domain + "/adminapi/v1/secretary/update";
                            params = {
                                id: this.msgId,
                                msgContent: this.form.msgContent,
                                msgHeadline: this.form.msgHeadline,
                                msgSubheadline: this.form.msgSubheadline,
                                redirectH5Url: this.form.redirectH5Url
                            };
                        } else {
                            if (this.form.pushRange == "2" && !this.schoolsArr.length) {
                                this.$util.errorMsg("请添加消息应用学校");
                                return;
                            }

                            if (this.form.pushRange == "3" && !this.studentArr.length) {
                                this.$util.errorMsg("请添加消息应用学生uid");
                                return;
                            }

                            if (this.form.pushRange == "2") {
                                pushContentList = this.schoolsArr.map((item) => {
                                    return item.rootUnid
                                }).join(",");
                            } else if (this.form.pushRange == "3") {
                                pushContentList = this.studentArr.join(",");
                            }
                            params = {
                                pushContentList: pushContentList,
                                msgStatus: 0,
                                coverPic: this.form.coverPic,
                                msgContent: this.form.msgContent,
                                msgHeadline: this.form.msgHeadline,
                                msgPurpose: this.form.msgPurpose,
                                msgSubheadline: this.form.msgSubheadline,
                                msgType: this.form.msgType * 1,
                                pushRange: this.form.pushRange * 1,
                                redirectH5Url: this.form.redirectH5Url
                            }
                        }

                        this.$http({
                            url,
                            method: 'POST',
                            body: JSON.stringify(params)
                        }).then((response) => {
                            if (response.data.error == 10000) {
                                this.$util.successMsg("保存成功", '提示');
                                this.cancel();
                            } else {
                                this.$util.errorMsg(response.data.message, '提示');
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .newMsg {
        min-height: calc(100vh - 60px);
    }

    .msgContent {
        width: 45%;
    }

    .myInput {
        width: 45%;
        display: inline-block;
        margin-right: 10px;
    }

    .campsBox {
        width: 70%;
        height: 200px;
        overflow-y: scroll;
        border: solid 1px #e3e3e3;
        margin-top: 20px;
        padding: 10px;
    }

    .s_item {
        display: inline-block;
        padding: 8px 5px 8px 20px;
        border: solid 1px #e3e3e3;
        box-sizing: border-box;
        font-size: 12px;
        border-radius: 5px;
        margin-right: 10px;
        margin-top: 10px;
        cursor: pointer;
    }

    .closeIcon {
        margin-left: 10px;
    }
</style>


// WEBPACK FOOTER //
// newMsg.vue?55768acc